// generated by the plop

import { PaginateQuery, PaginatorModel, UnknownError, UUID } from 'symbols';
import {
  CompletedWorkFilterModel,
  CompletedWorkTransactionExpectBackend,
  CompletedWorkTransactionModel
} from '../../symbols';

export class GetCompletedWorkTransactions {
  static type = '[completedWork] GetCompletedWorkTransactions';

  constructor(public lazy?: boolean, public filter?: PaginateQuery<CompletedWorkFilterModel>) {
  }
}

export class GetCompletedWorkTransactionsSuccess {
  static type = '[completedWork] GetCompletedWorkTransactionsSuccess';

  constructor(public transactions: PaginatorModel<CompletedWorkTransactionModel>, public lazy: boolean) {
  }
}

export class GetCompletedWorkTransactionsFail {
  static type = '[completedWork] GetCompletedWorkTransactionsFail';

  constructor(public error: UnknownError) {
  }
}

export class GetSummaryByUserId {
  static type = '[completedWork] GetSummaryByUserId';

  constructor(public userId: UUID, public date: string) {
  }
}

export class GetSummaryGroupedByWorker {
  static type = '[completedWork] GetSummaryGroupedByWorker';

  constructor(public date: string) {
  }
}

export class CreateCompletedWorkTransaction {
  static type = '[completedWork] CreateCompletedWorkTransaction';

  constructor(public transaction: CompletedWorkTransactionExpectBackend) {
  }
}

export class CreateCompletedWorkTransactionSuccess {
  static type = '[completedWork] CreateCompletedWorkTransactionSuccess';

  constructor(public transaction: CompletedWorkTransactionModel) {
  }
}

export class UpdateCompletedWorkTransaction {
  static type = '[completedWork] UpdateCompletedWorkTransaction';

  constructor(public transaction: CompletedWorkTransactionExpectBackend, public id: UUID) {
  }
}

export class CreateCompletedWorkTransactionSuccessWs {
  static type = '[completedWork] CreateCompletedWorkTransactionSuccessWs';

  constructor(public transaction: CompletedWorkTransactionModel) {
  }
}

export class DeleteCompletedWorkTransaction {
  static type = '[completedWork] DeleteCompletedWorkTransaction';

  constructor(public id: UUID) {
  }
}


export class DeleteCompletedWorkTransactionSuccess {
  static type = '[completedWork] DeleteCompletedWorkTransactionSuccess';
}

